// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","351":"commons","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"050c4edc4aeecfbf728f","351":"9d08038d1eaa16be7c27","532":"d7464a674d23b4974fa5","691":"22de3c1d1d752ac87976"}[chunkId] + ".js";
};